// rpc/RpcProvider.tsx
import React, { createContext, useContext, useMemo } from 'react'
import { createClient, Client } from '@connectrpc/connect'
import { createConnectTransport } from '@connectrpc/connect-web'

import { BrokersService } from '@/api/brokers/v1/brokers_pb'

type BrokersContextValue = {
	client: Client<typeof BrokersService>
}

const BrokersContext = createContext<BrokersContextValue | null>(null)

export function BrokersProvider(props: { baseUrl: string; children: React.ReactNode }) {
	const transport = useMemo(
		() =>
			createConnectTransport({
				baseUrl: props.baseUrl,
			}),
		[props.baseUrl],
	)

	const client = useMemo(() => createClient(BrokersService, transport), [transport])

	const value = useMemo(() => ({ client }), [client])

	return <BrokersContext.Provider value={value}>{props.children}</BrokersContext.Provider>
}

export function useBrokers() {
	const ctx = useContext(BrokersContext)
	if (!ctx) throw new Error('useBrokers must be used within <BrokersProvider>')
	return ctx
}
